// Entrar no backoffice: o mesmo formulário do site (SignInForm), com o passo do código 2FA.
import { useMe } from "@ecliptica/api-client/react";
import { Logo, SignInForm } from "@ecliptica/game-ui";
import { LanguageSwitch, useTranslation } from "@ecliptica/i18n";
import { Card, CardContent } from "@ecliptica/ui";
import { Navigate, useNavigate, useSearchParams } from "react-router";

export function LoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const me = useMe();
  const next = params.get("next")?.startsWith("/") ? params.get("next")! : "/";
  if (me.data) return <Navigate to={next} replace />;
  return (
    <div className="flex min-h-dvh items-center justify-center p-4">
      <div className="absolute right-4 top-4">
        <LanguageSwitch />
      </div>
      <Card className="w-full max-w-sm">
        <CardContent className="p-6">
          <Logo mono variant="stacked" className="mx-auto flex text-[11px]" />
          <h1 className="mt-4 text-2xl font-extrabold">{t("login.title")}</h1>
          <p className="mb-6 mt-1 text-sm text-muted-foreground">{t("login.lead")}</p>
          <SignInForm onSignedIn={() => navigate(next, { replace: true })} />
        </CardContent>
      </Card>
    </div>
  );
}
